import { render, staticRenderFns } from "./random.vue?vue&type=template&id=21ca1d1c&scoped=true&"
import script from "./random.vue?vue&type=script&lang=js&"
export * from "./random.vue?vue&type=script&lang=js&"
import style0 from "./random.vue?vue&type=style&index=0&id=21ca1d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ca1d1c",
  null
  
)

export default component.exports